import { useEffect, useState } from "react";
import { ArrowLeft, Instagram, MessageCircle } from "lucide-react";
import { useLenis } from "@/hooks/useLenis";
import { Idealize } from "@/components/site/Idealize";
import { MaskLinesInView } from "@/components/site/MaskInView";
import { CNPJ, IG_IDEALIZE, WHATSAPP_LABEL, waLink } from "@/lib/brand";

const IdealizeNav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <header data-testid="idealize-nav" className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${scrolled ? "bg-[#f8efe8]/85 backdrop-blur-xl border-b border-[#b08a3e]/20" : "border-b border-transparent"}`}>
      <nav className="mx-auto flex h-16 sm:h-20 max-w-[1400px] items-center justify-between px-5 sm:px-10 text-[#1d1a17]">
        <a href="/" data-testid="idealize-back-link" className="inline-flex items-center gap-2 font-jost text-xs tracking-[0.25em] hover:text-[#8a6a2c]"><ArrowLeft className="h-4 w-4" />SPEED MAX</a>
        <span className="font-jost text-sm tracking-[0.5em]">IDEALIZE</span>
        <a data-testid="idealize-nav-whatsapp" href={waLink("Olá, Idealize! Quero fazer uma caneca personalizada.")} target="_blank" rel="noreferrer" className="rounded-full bg-[#1d1a17] px-4 sm:px-5 py-2.5 font-jost text-xs tracking-[0.2em] text-[#f8efe8] hover:bg-[#8a6a2c]">PEDIR</a>
      </nav>
    </header>
  );
};

const IdealizeFooter = () => (
  <footer data-testid="idealize-footer" className="bg-[#1d1a17] text-[#f8efe8]">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-10 py-20 sm:py-28">
      <p className="font-serif-lux text-5xl sm:text-7xl leading-[1]">
        <MaskLinesInView lines={["Com você e para você,"]} />
        <MaskLinesInView lines={["sempre."]} delay={0.15} lineClass="italic text-[#c9a55c]" />
      </p>
      <div className="mt-16 grid grid-cols-1 gap-8 border-t border-[#c9a55c]/25 pt-10 sm:grid-cols-3 font-jost text-sm">
        <a data-testid="idealize-footer-whatsapp" href={waLink("Olá, Idealize! Quero fazer uma caneca personalizada.")} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-[#c9a55c]"><MessageCircle className="h-4 w-4" />{WHATSAPP_LABEL}</a>
        <a data-testid="idealize-footer-instagram" href={IG_IDEALIZE.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-[#c9a55c]"><Instagram className="h-4 w-4" />{IG_IDEALIZE.handle}</a>
        <p className="text-[#d9cfc6]">CNPJ {CNPJ} · Loja online</p>
      </div>
    </div>
  </footer>
);

export default function IdealizePage() {
  useLenis();
  useEffect(() => {
    window.scrollTo(0, 0);
    const prev = document.title;
    document.title = "Idealize Personalizados · Canecas Express";
    return () => { document.title = prev; };
  }, []);
  return (
    <main data-testid="idealize-page" className="bg-[#f8efe8] overflow-x-clip">
      <IdealizeNav />
      <Idealize />
      <IdealizeFooter />
    </main>
  );
}
